module.exports = __webpack_public_path__ + "static/img/tige_logo2.f21174e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tige_logo2.png
// module id = 9jR4
// module chunks = 14